/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select, TreeSelect } from 'antd';

const { Option } = Select;
const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const FormItem = Form.Item;

function UpdateForm({
  form,
  item: { name, role, user, organization },
  roleOptions,
  orgTreeNodes,
}) {
  const { getFieldDecorator } = form;
  return (
    <Form>
      <FormItem label="组织机构" {...formItemLayout}>
        {getFieldDecorator('organization', {
          rules: [{ required: false, message: '请输入机构名称' }],
          initialValue: organization,
        })(
          <TreeSelect
            showSearch
            style={{ width: '100%' }}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            placeholder="请选择"
            allowClear
            treeDefaultExpandAll
          >
            {orgTreeNodes}
          </TreeSelect>,
        )}
      </FormItem>
      {getFieldDecorator('user', {
        rules: [{ required: true }],
        initialValue: user,
      })(<Input type="hidden" />)}
      <FormItem label="用户名" {...formItemLayout}>
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请输入用户名' }],
          initialValue: name,
        })(<Input />)}
      </FormItem>
      <FormItem label="角色" {...formItemLayout}>
        {getFieldDecorator('role', {
          rules: [{ required: true, message: '请选择角色' }],
          initialValue: role,
        })(
          <Select
            showSearch
            dropdownMatchSelectWidth
            placeholder="请选择"
            style={{ width: '100%' }}
            filterOption={(inputValue, option) =>
              option.props.children.indexOf(inputValue) > -1
            }
          >
            {roleOptions.map(x => (
              <Option key={x.id} value={x.id}>
                {x.name}
              </Option>
            ))}
          </Select>,
        )}
      </FormItem>
    </Form>
  );
}

UpdateForm.propTypes = {
  form: PropTypes.shape().isRequired,
  item: PropTypes.shape().isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  roleOptions: PropTypes.array.isRequired,
  orgTreeNodes: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default Form.create()(UpdateForm);
